import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactMethods = () => {
  const contactMethods = [
    {
      id: 'email',
      title: 'Email',
      description: 'For formal inquiries and detailed discussions',
      value: 'lahiruprasangika2018@gmail.com',
      action: 'Send Email',
      icon: 'Mail',
      color: 'primary',
      href: 'mailto:lahiruprasangika2018@gmail.com',
      recommended: 'Best for project inquiries'
    },
    {
      id: 'linkedin',
      title: 'LinkedIn',
      description: 'Professional networking and career opportunities',
      value: '/in/lahiru-senavirathna-39b11a215',
      action: 'Connect',
      icon: 'Linkedin',
      color: 'accent',
      href: 'https://www.linkedin.com/in/lahiru-senavirathna-39b11a215',
      recommended: 'Best for recruiters'
    },
    {
      id: 'phone',
      title: 'WhatsApp',
      description: 'Quick questions and immediate responses',
      value: '+94 71 243 5202',
      action: 'Message',
      icon: 'MessageCircle',
      color: 'success',
      href: 'https://wa.me/94712435202',
      recommended: 'Best for urgent matters'
    },
    {
      id: 'github',
      title: 'GitHub',
      description: 'Code collaboration and open source projects',
      value: '/SE-LAPS',
      action: 'Follow',
      icon: 'Github',
      color: 'secondary',
      href: 'https://www.github.com/SE-LAPS',
      recommended: 'Best for developers'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/10 text-primary border-primary/20 hover:bg-primary/20',
      accent: 'bg-accent/10 text-accent border-accent/20 hover:bg-accent/20',
      success: 'bg-success/10 text-success border-success/20 hover:bg-success/20',
      secondary: 'bg-secondary/10 text-secondary border-secondary/20 hover:bg-secondary/20'
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Choose Your Preferred Way to Connect
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Multiple channels to ensure we can connect in the way that works best for you
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {contactMethods.map((method) => (
            <div
              key={method.id}
              className="group relative bg-card border border-border rounded-xl p-6 sm:p-8 hover:shadow-lg transition-premium hover-lift"
            >
              {/* Icon */}
              <div className={`inline-flex items-center justify-center w-14 h-14 rounded-lg border mb-6 ${getColorClasses(method.color)}`}>
                <Icon name={method.icon} size={28} />
              </div>

              {/* Content */}
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-text-primary mb-2">
                  {method.title}
                </h3>
                <p className="text-text-secondary mb-4">
                  {method.description}
                </p>
                <div className="bg-surface rounded-lg p-3 mb-4">
                  <p className="font-mono text-sm text-text-primary">
                    {method.value}
                  </p>
                </div>
                <div className="inline-flex items-center space-x-2 bg-muted px-3 py-1 rounded-full">
                  <Icon name="Star" size={14} className="text-warning" />
                  <span className="text-xs text-text-muted">{method.recommended}</span>
                </div>
              </div>

              {/* Action Button */}
              <a
                href={method.href}
                target={method.id === 'email' ? '_self' : '_blank'}
                rel={method.id === 'email' ? undefined : 'noopener noreferrer'}
                className="w-full inline-flex items-center justify-center px-4 py-2 border border-input rounded-md text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors group-hover:border-current group-hover:text-current"
              >
                <Icon name={method.icon} size={16} className="mr-2" />
                {method.action}
              </a>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl"></div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="bg-surface rounded-xl p-8 max-w-2xl mx-auto">
            <Icon name="Info" size={24} className="text-accent mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-text-primary mb-2">
              Communication Preferences
            </h3>
            <p className="text-text-secondary text-sm leading-relaxed">
              I typically respond to emails within 24 hours during weekdays. For urgent matters, 
              WhatsApp is the fastest way to reach me. I'm available for calls between 9 AM - 6 PM IST, 
              but can accommodate different time zones for international clients.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;